import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    loadingStatus: "idle",
    error: null
}

export const fetchDeleteVehicle = createAsyncThunk(
    'deleteVehicle/fetchDeleteVehicle',
    async ({token, id}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/vehicles/${id}`,
                'DELETE',
                null,
                customHeaders
            );

            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

const deleteVehicleSlice = createSlice({
    name: 'deleteVehicle',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDeleteVehicle.pending, (state) => {
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchDeleteVehicle.fulfilled, (state) => {
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchDeleteVehicle.rejected, (state, action) => {
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
});

export default deleteVehicleSlice.reducer;